/* Mobile menu burger toggle */
(function () {
    const mobileMenu = document.querySelector('.gh-navigation-menu');
    const burger = document.querySelector('.gh-burger');
    const mobileMenuCloseButton = document.querySelector('.mobile-nav-close-button');
    const backdrop = document.querySelector('.backdrop');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!mobileMenu.classList.contains('is-open')) {
            mobileMenu.classList.add('is-open');
            backdrop.classList.add('is-open');
            document.documentElement.style.overflowY = "hidden";
            // document.documentElement.style.overflowY = 'hidden';
        } else {
            mobileMenu.classList.remove('is-open');
            backdrop.classList.add('is-open');
            document.documentElement.style.overflow = null;
            // document.documentElement.style.overflowY = null;
        }
    });
    mobileMenuCloseButton.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        document.documentElement.style.overflow = null;
    });

    backdrop.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        backdrop.classList.remove('is-open');
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
// (function () {
//     if (!document.body.classList.contains('post-template')) {
//         pagination(isInfinite=false)
//     }
// })();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();